import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { LogoMark } from "./Logo";
import { prefersReduced } from "../lib/lenis";

export const Loader = ({ onDone }) => {
  const root = useRef(null);
  const [n, setN] = useState(0);

  useEffect(() => {
    const el = root.current;
    const reduced = prefersReduced();
    const counter = { v: 0 };
    const paths = el.querySelectorAll(".ld-path");
    paths.forEach((p) => {
      const len = p.getTotalLength();
      gsap.set(p, { strokeDasharray: len, strokeDashoffset: len });
    });
    const tl = gsap.timeline({ onComplete: onDone });
    tl.to(paths, { strokeDashoffset: 0, duration: reduced ? 0.2 : 1.1, ease: "power2.inOut", stagger: 0.12 }, 0)
      .to(counter, { v: 100, duration: reduced ? 0.2 : 1.2, ease: "power3.inOut", onUpdate: () => setN(Math.round(counter.v)) }, 0)
      .to(el.querySelector(".ld-center"), { opacity: 0, y: -20, duration: 0.4, ease: "power2.in" })
      .to(el.querySelector(".ld-top"), { yPercent: -100, duration: reduced ? 0.2 : 1, ease: "expo.inOut" }, "-=0.1")
      .to(el.querySelector(".ld-bot"), { yPercent: 100, duration: reduced ? 0.2 : 1, ease: "expo.inOut" }, "<");
    return () => {
      tl.kill();
    };
  }, [onDone]);

  return (
    <div ref={root} className="fixed inset-0 z-[100] pointer-events-none" data-testid="site-loader" aria-hidden="true">
      <div className="ld-top absolute inset-x-0 top-0 h-1/2 bg-[#07080d] border-b border-[#d4af37]/20" />
      <div className="ld-bot absolute inset-x-0 bottom-0 h-1/2 bg-[#07080d]" />
      <div className="ld-center absolute inset-0 flex flex-col items-center justify-center gap-6">
        <LogoMark className="w-20 h-20" draw />
        <p className="font-display tracking-[0.5em] text-xs text-[#e7d48f]">BOSS EMPIRE</p>
        <p className="font-mono text-[12px] text-slate-400 tabular-nums">{String(n).padStart(3, "0")}%</p>
      </div>
    </div>
  );
};
